//----- Component --------------------------------------------------------/
// Developer     : Magali Perea
// Creation Date : 28/06/2023
// Version       : 1
// Description   :
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date   : 14/07/2025
// Change by     : Guillermo Sedran
// Change description: Refactor
//
// Change Date   :
// Change by     :
// Change description:
//
//========================================================================/

import { useEffect, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { getData } from "../../../../../services/library";

function HistorialTanque(props) {
  const [movimientos, setMovimientos] = useState();

  useEffect(() => {
    getData(
      `/movimientos_tanques/${props.datos.id}/${props.datos.nro_tanque}`,
      setMovimientos
    );
  }, []);

  return (
    <div>
      <Container maxWidth="lg" disableGutters>
        {movimientos ? (
          movimientos.length > 0 ? (
            <Grid container spacing={2} marginTop={1}>
              {movimientos.map((movimiento) => (
                <Grid item xs={12} sm={12} key={movimiento.idmovimiento}>
                  <Box
                    p={1.5}
                    backgroundColor="#EAF2F8"
                    border={1}
                    borderColor="#D4E6F1"
                  >
                    {movimiento.cliente && (
                      <Typography variant="body1">
                        <strong>Cliente:</strong> {movimiento?.cliente}
                      </Typography>
                    )}
                    {movimiento.sucursal && (
                      <Typography variant="body1">
                        <strong>Sucursal:</strong>{" "}
                        {movimiento?.sucursal || "No registrado."}
                      </Typography>
                    )}
                    {movimiento.nro_remito && (
                      <Typography variant="body1">
                        <strong>Remito:</strong> {movimiento.nro_remito}
                      </Typography>
                    )}
                    {movimiento.fecha && (
                      <Typography variant="body1">
                        <strong>Fecha Remito:</strong> {movimiento.fecha}
                      </Typography>
                    )}
                    <Typography variant="body1">
                      <strong>Registrado:</strong>{" "}
                      {movimiento?.created_at || "No registrado."}
                    </Typography>
                    {movimiento.observaciones && (
                      <Typography variant="body1">
                        <strong>Observaciones:</strong>{" "}
                        {movimiento.observaciones}
                      </Typography>
                    )}
                  </Box>
                </Grid>
              ))}
            </Grid>
          ) : (
            <Typography variant="body1" textAlign="center" my={2}>
              No hay movimientos registrados para este tanque.
            </Typography>
          )
        ) : (
          <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
          >
            <Grid item xs>
              <Typography m={4} fontSize={22} variant="h2" color="initial">
                Cargando historial del tanque..
              </Typography>
            </Grid>
            <Grid item>
              <CircularProgress color="primary" />
            </Grid>
          </Grid>
        )}
      </Container>
    </div>
  );
}

export default HistorialTanque;
